<template>
    <li
        :class="{ 'firstParent': !item.parent_id }"
        class="item"
    >
        <div class="category flex justify-between items-center">
            <router-link
                :to="`${urlBase}/${item.id}`"
                class="title"
            >
                {{ item.title }}
            </router-link>
            <div class="buttons">
                <router-link
                    v-tooltip="'Edit item'"
                    :to="`${urlBase}/${item.id}`"
                    class="iconButton"
                >
                    <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"/><path d="M18 2l4 4-10 10H8v-4L18 2z"/></svg>
                </router-link>
                <button
                    v-tooltip="'Remove item'"
                    type="button"
                    class="iconButton"
                    @click="$emit('deleteItem', item)"
                >
                    <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M10 11v6M14 11v6"/></svg>
                </button>
            </div>
        </div>
        <ul
            v-if="item.children"
            class="children list-reset"
        >
            <draggable
                :list="item.children"
                @change="$emit('orderChanged', item.children)"
            >
                <CategoriesListItem
                    v-for="child in item.children"
                    :key="child.id"
                    :item="child"
                    :url-base="urlBase"
                    @orderChanged="items => $emit('orderChanged', items)"
                    @deleteItem="item => $emit('deleteItem', item)"
                />
            </draggable>
        </ul>
    </li>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    name: 'CategoriesListItem',
    components: {
        draggable,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        urlBase: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="postcss" scoped>
.item.sortable-ghost {
    opacity: 0.5;
}
.category {
    padding: 12px 20px;
    box-shadow: var(--shadow);
    background-color: #fff;
    margin-bottom: 15px;
    font-size: 18px;
    border-radius: var(--borderRadius);
    @media (--laptop) {
        font-size: 17px;
    }
}
.children {
    padding-left: 25px;
}
.title {
    font-size: 15px;
    &:hover {
        color: var(--primary);
    }
}
.firstParent > .category {
    padding: 18px 25px;
}
.firstParent > .category .title {
    font-size: 16px;
    @media (--laptop) {
        font-size: 15px;
    }
}
.iconButton {
    margin-right: 12px;
    display: inline-block;
    line-height: 0;
    color: var(--grey600);
    &:hover .icon {
        color: var(--primary);
    }
    &:last-child {
        margin-right: 0;
    }
}
.icon {
    width: 20px;
    height: 20px;
    @media (--laptop) {
        width: 18px;
        height: 18px;
    }
}
.category:hover {
    cursor: move;
}
</style>
